<template>
	<div class="multiple-attribute multicheckbox-editor" :id="attributeName + '__area'" :max-count="maxCount">
		<div class="col-sm-5">
			<label :id="attributeName + '_label'" :for="attributeName"
				   :data-description="localizedTitle"
				   :title="$t(localizedTitle)">
				<span v-if="enableCopyAttributeName" class="fa fa-files-o label-copy-icon"
					  v-bind-copy-to-clipboard="attributeName"/>
				<span v-if="requiredLabelIcon" :class="requiredLabelIcon"/>
				<span v-if="requiredPrimaryIcon" :class="requiredPrimaryIcon"/>
				<i v-if="lockedEdit" class="fa fa-lock"/>
				<label-tooltip :label="$t(localizedTitle)"/>
			</label>
		</div>
		<div class="col-sm-7">
			<template v-if="lockedEdit">
				<div class="locked-block">
					<span v-for="value in attributeValue">
						{{ options[value] + ", "}}
					</span>
				</div>
			</template>
			<template v-else>
				<div tabindex="0" class="attribute-editor mcb-drop-down-wrapper" :id="attributeName">
					<div class="mcb-drop-down-btn fa fa-list-ul"></div>
					<div class="value-list"></div>
				</div>
				<div class="mcb-item-list">
					<div class="mcb-controls">
						<div class="mcb-clear blank" tabindex="0"></div>
						<input class="mcb-search" type="text">
						<button class="button_reset fa fa-times" tabindex="-1"/>
					</div>
					<ul class="checkbox-list">
						<li v-for="(value, key) in options"><input class="attribute-editor bg-editor" type="checkbox"
																   :value="key">{{ $t(value) || value }}
						</li>
					</ul>
					<ul class="checkbox-sublist"></ul>
				</div>
			</template>
		</div>
	</div>
</template>

<script>

import { initMulticheckboxAttribute } from '@/core/item_assistance/initItemData'
import { attributeLabel } from '@/mixins/attributeLabel'
import LabelTooltip from 'components/item-edit/partials/LabelTooltip'

export default {
	components: {
		LabelTooltip
	},
	name: 'MultipleLAttributeEditorComponent',
	props: [
		'attributeName',
		'localizedTitle',
		'isMultiple',
		'isPrimary',
		'maxLength',
		'maxCount',
		'defaultValue',
		'defaultLock',
		'colspan',
		'classificators',
		'localization',
		'classificatorType',
		'enableCopyAttributeName',
		'itemData',
		'lockedEdit'
	],
	mixins: [
		attributeLabel
	],
	data () {
		return {
			single: !this.isMultiple,
			options: this.classificators[this.classificatorType],
			SINGLE_ATTRIBUTE: 'single-attribute'
		}
	},
	computed: {
		attributeValue: {
			get () {
				return this.itemData || []
			},
			set () {

			}
		}
	},
	watch: {
		attributeValue: function () {
			initMulticheckboxAttribute(this.attributeName, this.attributeValue)
		}
	},
	directives: {
		bindCopyToClipboard: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'CopyToClipboard(\'{' + binding.value + '}\')')
			}
		}
	},
	mounted () {
		initMulticheckboxAttribute(this.attributeName, this.attributeValue)
	}
}
</script>

<style scoped>
.locked-block {
	border: 1px solid #cccccc;
	padding: 2px;
	font-size: 12px;
	background-color: #fafafa;
	min-height: 25px;
}
</style>
